import { router, useLocalSearchParams } from 'expo-router';
import { useAtomValue } from 'jotai';
import { TabPanel, TabView } from 'primereact/tabview';
import React from 'react';
import { BodySmallEmphasized } from 'smoothie';

import { FullPageContainer } from '../../common/components/GroveContainers';
import { adminUserAtom } from '../../entities/entityAtoms';
import { DbosDashboard } from './DbosDashboard';
import { ImOpsBridgeftPerformancePanel } from './ImOpsBridgeftPerformance';
import { ImOpsCashJournalsPanel } from './ImOpsCashJournals';
import { ImOpsCompliancePanel } from './ImOpsCompliancePanel';
import { ImOpsIctDailyPanel } from './ImOpsIctDaily';
import { ImOpsManualIctWithdrawalsPanel } from './ImOpsManualIctWithdrawalsPanel';
import { ImOpsRebalancerPanel } from './ImOpsRebalancerPanel';

export const ImOpsPage = () => {
    const adminUser = useAtomValue(adminUserAtom);
    const { dt: selectedTabIndex } = useLocalSearchParams<{ dt: string }>();

    if (!adminUser.authorization.imOpsFunctionality.canUse) {
        return (
            <BodySmallEmphasized color="$red1100" marginVertical="auto">
                No access to Investment Management Operations
            </BodySmallEmphasized>
        );
    }

    const selectedTabIndexNum = parseInt(selectedTabIndex, 10) || 0;

    return (
        <FullPageContainer>
            <TabView
                style={{ width: '100%', marginTop: '-0.5vw' }}
                panelContainerStyle={{
                    width: '100%',
                    padding: 0,
                    marginTop: 32,
                }}
                activeIndex={selectedTabIndexNum}
                onTabChange={(e) => {
                    router.setParams({ dt: e.index.toString() });
                }}
            >
                <TabPanel header="ICT Daily">
                    <ImOpsIctDailyPanel />
                </TabPanel>
                <TabPanel header="ICT Withdrawal Requests">
                    <ImOpsManualIctWithdrawalsPanel />
                </TabPanel>
                <TabPanel header="DBOS Dashboard">
                    <DbosDashboard />
                </TabPanel>
                <TabPanel header="Compliance">
                    <ImOpsCompliancePanel />
                </TabPanel>
                <TabPanel header="Cash Journals">
                    <ImOpsCashJournalsPanel />
                </TabPanel>
                <TabPanel header="BridgeFT Performance">
                    <ImOpsBridgeftPerformancePanel />
                </TabPanel>
                <TabPanel header="Rebalancer">
                    <ImOpsRebalancerPanel />
                </TabPanel>
            </TabView>
        </FullPageContainer>
    );
};
